export const errors = {
  required: 'This field is required',
  email: 'Please enter valid email address',
  dateOfBirth: 'Please enter valid date of birth',
  atLeastOne: 'At least one field has to be provided',
  invalidEmailOrPhone: 'Field must be valid email or phone number',
  minlength: 'The no. of characters should not be less than {{requiredLength}}',
  maxlength: 'The no. of characters should be more than {{requiredLength}}',
  notValid: 'Field is not valid',
  somethingWentWrong: 'Oops, something went wrong',
  scheduleOutsideWorkingHours:
    'Getting in line is currently unavailable as the hospital is closed. Please use the ’Schedule for later’ option.',
  contactInUse: '{{ contact }} already in use. Please try another.',
  invalidPhone: 'Invalid phone number',
  poBox: 'We do not ship to PO Boxes. Please enter a residential or business address.',
  unknownAddress: 'Unknown address',
  validateAddress: 'Error while validating address',
};
